export default __webpack_public_path__ + "static/media/clock.73b568e0.svg";